import type { ApiTypingsLookup } from "@/api";

import { registerPreviewHandler, type PreviewHandler } from "../registry";
import {
  handleAnalyticsFunnelQuery,
  handleFunnelQuery,
  handleListFunnels,
} from "./funnels";
import { handleListActiveDestinations } from "./destinations";
import {
  handleGetDynamicEvents,
  handleGetEventDefsEnriched,
} from "./event-defs";
import {
  handleGetSurvey,
  handleGetSurveyResponses,
  handleGetSurveyResults,
  handleGetSurveyTimeseries,
  handleGetSurveys,
} from "./surveys";
import {
  handleAnalyticsConversionQuery,
  handleAnalyticsEventQuery,
  handleAnalyticsPrecisionEventQuery,
} from "./web-analytics";

// ApiTypingsLookup declares survey responses as parsed FE shapes (e.g.
// Survey[]), but front/src/surveys/api.ts deserializes the wire shape
// ({ surveys: BackendSurvey[] }). Our handlers return the wire shape so
// the deserializer keeps working; this cast bridges the disconnect
// without forcing a refactor of api/surveys.ts.
function asPreviewHandler<K extends keyof ApiTypingsLookup>(
  fn: (params: ApiTypingsLookup[K]["request"]) => unknown,
): PreviewHandler<K> {
  return fn as PreviewHandler<K>;
}

export function registerAllPreviewModeHandlers(): void {
  registerPreviewHandler("list_funnels", handleListFunnels);
  registerPreviewHandler("analytics_funnel_query", handleAnalyticsFunnelQuery);
  registerPreviewHandler("funnel_query", handleFunnelQuery);
  registerPreviewHandler("get_event_defs_enriched", handleGetEventDefsEnriched);
  registerPreviewHandler("get_dynamic_events2", handleGetDynamicEvents);
  registerPreviewHandler(
    "list_active_destinations",
    handleListActiveDestinations,
  );

  registerPreviewHandler("analytics_event_query", handleAnalyticsEventQuery);
  registerPreviewHandler(
    "analytics_conversion_query",
    handleAnalyticsConversionQuery,
  );
  registerPreviewHandler(
    "analytics_precision_event_query",
    handleAnalyticsPrecisionEventQuery,
  );

  registerPreviewHandler(
    "get_surveys",
    asPreviewHandler<"get_surveys">(handleGetSurveys),
  );
  registerPreviewHandler(
    "get_survey",
    asPreviewHandler<"get_survey">(handleGetSurvey),
  );
  registerPreviewHandler(
    "get_survey_results",
    asPreviewHandler<"get_survey_results">(handleGetSurveyResults),
  );
  registerPreviewHandler(
    "get_survey_timeseries",
    asPreviewHandler<"get_survey_timeseries">(handleGetSurveyTimeseries),
  );
  registerPreviewHandler(
    "get_survey_responses",
    asPreviewHandler<"get_survey_responses">(handleGetSurveyResponses),
  );
}
